document.addEventListener('DOMContentLoaded', function () {
    function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        var html = document.documentElement;
        return (
            rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= (window.innerHeight || html.clientHeight) &&
            rect.right <= (window.innerWidth || html.clientWidth)
        );
    }

    function runCountUp() {
        document.querySelectorAll('[num]').forEach(n => {
            var ran = false;
            if (isInViewport(n) && !ran) {
                const finalValue = parseInt(n.getAttribute('num'), 10);

                const updateCount = () => {
                    const count = +n.innerText.replace(/,/g, ''); // Remove commas for proper calculation
                    const speed = 350;
                    const inc = finalValue / speed;
                    if (count < finalValue) {
                        n.innerText = Math.ceil(count + inc).toLocaleString(); // Add thousands separator
                        setTimeout(updateCount, 1);
                    } else {
                        n.innerText = finalValue.toLocaleString(); // Ensure final value is formatted
                    }
                };
                updateCount();
                ran = !ran;
            }
        });
    }

    runCountUp();

    window.addEventListener(
        'scroll',
        function () {
            runCountUp();
        },
        false
    );
});